import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Administrateur } from 'src/app/shared/models/administrateur';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-add-administrateurs',
  standalone: false,
  templateUrl: './add-administrateurs.component.html',
  styleUrl: './add-administrateurs.component.scss'
})
export class AddAdministrateursComponent {

  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,

  ) { }

  item: Administrateur = new Administrateur();

  departementItems: any = [];
  communeItems: any = [];
  arrondissementItems: any = [];
  cooperativeItems: any = [];

  ngOnInit() {
    this.getPays();
    this.item.user_reference = this.localStorage.getUsers().data.reference;
  }
  addAdministrateur() {

    if (!this.item.canSave()) {

      this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: this.item.getErrorMessage() });

    }
    else if (this.item.canSave()) {

      this.ngxService.start();
      this.authService.addAdministrateur(this.item).subscribe(
        (response: any) => {
          //console.log("la reponse du webservice",response);
          this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });

          this.fecthDataService.notifySeriviceCreated();
          this.modalService.dismissAll();

          this.ngxService.stop();

        },
        (error: any) => {
          //console.log("une erreur est survenu",error);
          // this.modalService.dismissAll()
          this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail:error });
          this.ngxService.stop();

        }
      )
    }


  }
  getPays() {
    this.paramService.getPays().subscribe(

      (response: any) => {
        this.departementItems = response.data;
        this.getCooperative();
        console.log("this.departementItems", this.departementItems);
      },
      (error) => {
        console.log("une erreur est survenu", error);

      }

    );
  }

  getvilleByPays(departementId: number) {
    this.paramService.getVilleById(departementId).subscribe(
      (response: any) => {
        this.communeItems = response.data;
        console.log("Liste des communes pour le département", departementId, ":", this.communeItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des communes :", error);
      }
    );
  }
  getArrondissementByCommune(communeId: number) {
    this.paramService.getVilleById(communeId).subscribe(
      (response: any) => {
        this.arrondissementItems = response.data;
        console.log("Liste des arrondissements pour la commune", communeId, ":", this.arrondissementItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des arrondissements :", error);
      }
    );
  }

  getCooperative() {
    this.paramService.getCooperative().subscribe(

      (response: any) => {
        this.cooperativeItems = response.data;
        console.log("this.cooperativeItems", this.cooperativeItems);
      },
      (error) => {
        console.log("une erreur est survenu", error);

      }

    );
  }


  close() {

    this.modalService.dismissAll();
  }


}
